import { ValueLabelPair } from '../Input/Dropdowns/SingleSelect/types';

export const CHOOSE_LANGUAGE_MODAL_WIDTH = 496;

export const LANGUAGES: ValueLabelPair[] = [
  {
    label: 'English (EN)',
    value: 'en',
    ariaLabel: 'English, Select your language',
  },
  {
    label: 'Tiếng Việt (VI)',
    value: 'vi',
    ariaLabel: 'Tiếng Việt, Chọn ngôn ngữ',
  },
  {
    label: 'Bahasa Indonesia (ID)',
    value: 'id',
    ariaLabel: 'Bahasa Indonesia, Pilih bahasa Anda',
  },
  {
    label: 'Bahasa Melayu (MS)',
    value: 'ms',
    ariaLabel: 'Bahasa Melayu, Pilih bahasa Anda',
  },
];
